import * as React from "react";
import { NumberInput } from "../ui/Input";
import { IconButton } from "../ui/IconButton";
import { Icon } from "../ui/Icon";
import { Label } from "../ui/Label";
import Abacus from "../../icons/abacus.svg?react";

export interface KcalInputProps {
  value: number;
  onChange: (kcal: number) => void;
  onOpenCalculator: () => void;
}

export const KcalInput = ({
  value,
  onChange,
  onOpenCalculator,
}: KcalInputProps) => (
  <div>
    <Label>Kalorienbedarf</Label>
    <div className="mt-1.5 flex items-center gap-2">
      <NumberInput
        value={value}
        onValueChange={(v) => onChange(v ?? 0)}
        unit="kcal / Tag"
        className="text-base font-bold"
      />
      <IconButton
        label="Grundumsatz berechnen"
        onClick={onOpenCalculator}
        className="h-10 w-10"
      >
        <Icon size={28}>
          <Abacus />
        </Icon>
      </IconButton>
    </div>
  </div>
);
